import CustomInput from "@/components/CustomInput/CustomInput.vue";

export default {
    name: 'Reset',
    components: {CustomInput},
    data() {
        return {
            email: '',
            success: false,
            error: false,
            errorMessage: '',
            message: '',
            touched: false,
            emailSend: false,
        }
    },
    watch: {
        email() {
            this.errorMessage = ''
            this.emailSend = false
        }
    },
    methods: {
        emailInput(data) {
            this.error = false
            this.touched = true
            this.email = data
            if (!this.email.invalide) {
                console.log('-')
            } else {
                this.error = true
            }
        },
        disableFormSend() {
            document.getElementById('confirm_reset_btn').click();
            return false;
        },
        reset() {
            this.emailSend = true;
            this.$store.dispatch('resetPasswordSetClient', this.email)
                .then(res => {
                    if (res.status === 200) {
                        this.emailSend = true;
                        this.success = true
                    } else {
                        this.emailSend = false;
                        this.error = true
                    }
                })
                .catch((error) => {
                    console.log('error')
                    console.log(error.response.data.error)
                    this.errorMessage = error.response.data.error
                })
        }
    }
}